import React from 'react';
import { OP_STATUS } from "../../../../../util/varibles/constants";
import { TOperation2 } from "../../../../../util/varibles/interface";
import { getPopupOpInfo } from '../../PopupOpInfoContext';

interface IProps {
    operation: {
        status: TOperation2['status']
        approver?: TOperation2['approver']
    }
}

const Approver: React.FC<IProps> = ({ operation }) => {
    const { isOwn } = getPopupOpInfo()();
    const { status, approver } = operation;
    const isApprover = !isOwn && ((status === OP_STATUS.WAITING || status === OP_STATUS.CANCELED) && approver);

    if (!isApprover)
        return null;

    return <div className='mb-10'>
        {approver + (status === OP_STATUS.CANCELED ? ' canceled' : ' approved')}
    </div>
};

export default Approver;
